import { CommonModule, NgIf } from '@angular/common';
import { Component, Input} from '@angular/core';
import { RouterLink } from "@angular/router";

@Component({
  selector: 'app-header-cascading-link',
  templateUrl: './header-cascading-link.component.html',
  styleUrls: ['./header-cascading-link.component.scss'],
  standalone:true,
  imports: [NgIf, CommonModule, HeaderCascadingLinkComponent, RouterLink]
})
export class HeaderCascadingLinkComponent {
  @Input() subCategories!: any;
  @Input() flip!:any;
  isOpen = false;

  onEnter() {
    this.isOpen = true;
  }

  onLeave() {
    this.isOpen = false;
  }
}
